<template>
  <div class="limiter">
    <div class="container-login100 ">
      <div class="wrap-login100 ">
        <form
          ref="formLogout"
          class="login100-form bg-white"
          @submit.prevent="submit"
        >
          <span class="login100-form-title">
            Registro de Usuario
          </span>
          <div class="mb-4">
            <label for="name">Nombre</label>
            <input
              id="name"
              class="form-control py-4 mb-2"
              v-validate="'required'"
              type="text"
              data-vv-validate-on="blur|input"
              data-vv-name="nombre"
              v-model="logup.firstName"
              placeholder="Pedro"
            />
            <span class="text-danger fs-6" v-show="errors.has('nombre')">
              Este campo es requerido
            </span>
          </div>

          <div class="mb-4">
            <label for="name">Apellido</label>
            <input
              id="lastName"
              class="form-control py-4 mb-2"
              v-validate="'required'"
              type="text"
              data-vv-validate-on="blur|input"
              data-vv-name="lastName"
              v-model="logup.lastName"
              placeholder="Matos"
            />
            <span class="text-danger fs-6" v-show="errors.has('lastName')">
              Este campo es requerido
            </span>
          </div>

          <div class="mb-4">
            <label for="email">Correo Electrónico</label>
            <input
              id="email"
              class="form-control py-4 mb-2"
              v-validate="'required'"
              type="Email"
              data-vv-validate-on="blur|input"
              data-vv-name="email"
              v-model="logup.email"
              placeholder="referencia@example.com"
            />
            <span class="text-danger fs-6" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>

          <div class="mb-4">
            <label for="password">Contraseña</label>
            <input
              ref="password"
              id="password"
              class="form-control py-4 mb-2"
              v-validate="'required|min:6'"
              type="password"
              data-vv-validate-on="blur|input"
              data-vv-name="password"
              v-model="logup.password"
            />
            <span class="text-danger fs-6" v-show="errors.has('password')">{{
              errors.first("password")
            }}</span>
          </div>

          <div class="mb-4">
            <label for="confirmar">Confirmar contraseña</label>
            <input
              id="confirmar"
              class="form-control py-4 mb-2"
              v-validate="'required|confirmed:password'"
              type="password"
              data-vv-validate-on="blur|input"
              data-vv-name="confirmar"
              v-model="password"
            />
            <span class="text-danger fs-6" v-show="errors.has('confirmar')">{{
              errors.first("confirmar")
            }}</span>
          </div>
          <!--  v-if="loading" -->
          <div class="container-login100-form-btn mt-4">
            <button :disabled="loading" type="submit" class="login100-form-btn">
              <b-spinner v-if="loading"  class="mr-2" small></b-spinner>
              Registrar
            </button>
          </div>
          <div class="text-center mt-4 p-t-46 p-b-20 p-t">
            <button
              class="login100-form-btn login100-form-btn-outline "
              @click="goLogin"
            >
              Iniciar sesión
            </button>
          </div>

          <div class="login100-form-social flex-c-m">
            <a href="#" class="login100-form-social-item flex-c-m bg1 m-r-5">
              <i class="fa fa-facebook-f" aria-hidden="true"></i>
            </a>

            <a href="#" class="login100-form-social-item flex-c-m bg2 m-r-5">
              <i class="fa fa-twitter" aria-hidden="true"></i>
            </a>
          </div>
        </form>

        <div class="login100-more"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Registro",
  data() {
    return {
      loading:false,
      logup: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
      },
      password: "",
    };
  },

  methods: {
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch({ type: "login/logup", data: this.logup })
            .then((resp) => {
              this.$swal.fire("Éxito", `${resp.message}`, "success");
              this.logup = {
                firstName: "",
                lastName: "",
                email: "",
                password: "",
              };
              this.password = "";
              this.loading = false;
            })
            .catch((e) => {
              this.$swal.fire("Error", `${e.message}`, "error");
              this.loading = false;
            });
        }
      });
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
  computed: {},
};
</script>
